import { Box, Tab, Tabs, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
// import CarePlan from './CarePlan/CarePlan';
import CurrentNeedsMemberDetail from './CurrentNeedsMemberDetail/CurrentNeedsMemberDetail';

import SafetyPlan from './SafetyPlan/SafetyPlan';
import BehavioralPlan from './BehavioralPlan/BehavioralPlan';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { RootState } from '../../reducers';
import { useParams } from 'react-router-dom';
import ReportIcon from '@mui/icons-material/Report';
import { getMemberByMemberId } from '../../store/memberDemographicsDetails.slice';
import { fetchSafetyPlanByMemberId } from '../../store/behaviorOrSafetyPlanSlice.slice';
import { PlanStatusEnum } from '../../Enum/PlanStatusEnum';
import CarePlan from './CarePlan/CarePlan';

const SAFETY_PLAN_TAB_INDEX = 2;

const IntegratedCarePlan = () => {
    const dispatch = useAppDispatch();
    const params = useParams();
    const [activeTab, setActiveTab] = useState(0);
    const [hasAutoOpenedSafetyPlan, setHasAutoOpenedSafetyPlan] = useState(false);
    const { chartDetails } = useSelector((state: RootState) => state.memberDemographicsDetails);
    const { safetyPlanInfo } = useSelector((state: RootState) => state.safetyPlanSlice);

    useEffect(() => {
        dispatch(getMemberByMemberId(params.memberId));
        dispatch(fetchSafetyPlanByMemberId(params.memberId));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (hasAutoOpenedSafetyPlan || safetyPlanInfo?.Status === PlanStatusEnum.Declined) {
            return;
        }

        const hasContent =
            safetyPlanInfo?.Status === PlanStatusEnum.Created ||
            Boolean(safetyPlanInfo?.MostImportant?.trim()) ||
            (safetyPlanInfo?.Triggers?.length ?? 0) > 0 ||
            (safetyPlanInfo?.WarningSigns?.length ?? 0) > 0 ||
            (safetyPlanInfo?.Strategies?.length ?? 0) > 0 ||
            (safetyPlanInfo?.PositiveDistractions?.length ?? 0) > 0 ||
            (safetyPlanInfo?.People?.length ?? 0) > 0 ||
            (safetyPlanInfo?.Agencies?.length ?? 0) > 0 ||
            (safetyPlanInfo?.Environments?.length ?? 0) > 0 ||
            (safetyPlanInfo?.Avoids?.length ?? 0) > 0;

        if (hasContent) {
            setActiveTab(SAFETY_PLAN_TAB_INDEX);
            setHasAutoOpenedSafetyPlan(true);
        }
    }, [hasAutoOpenedSafetyPlan, safetyPlanInfo]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const a11yProps = (index: number) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            'aria-controls': `scrollable-auto-tabpanel-${index}`,
        };
    };

    return (
        <Box>
            <Tabs
                value={activeTab}
                onChange={handleChange}
                // variant="scrollable"
                variant="fullWidth"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={{ borderBottom: 1, borderColor: 'divider', textAlign: 'center' }}
            >
                <Tab label="Care Plan" {...a11yProps(0)} />
                <Tab label="Current Needs" {...a11yProps(1)} />
                <Tab
                    {...a11yProps(2)}
                    label={
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            Safety Plan
                            {chartDetails?.SafetyPlanNeeded && (
                                <Tooltip title={'Safety Plan Recommended'} placement="right">
                                    <ReportIcon sx={{ color: 'error.main', marginLeft: '8px' }} />
                                </Tooltip>
                            )}
                        </Box>
                    }
                />
                <Tab {...a11yProps(3)} label={<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Behavioral Plan</Box>} />
            </Tabs>
            {activeTab === 0 && <CarePlan />}
            {activeTab === 1 && <CurrentNeedsMemberDetail />}
            {activeTab === 2 && <SafetyPlan />}
            {activeTab === 3 && <BehavioralPlan />}
        </Box>
    );
};

export default IntegratedCarePlan;
